import React from 'react'
import TemplatizedTextField, {
    type TemplatizedTextFieldProps,
} from '@pushly/aqe/lib/components/templatized-text-field/templatized-text-field'

interface ITemplateBodyField extends TemplatizedTextFieldProps {}

const TemplateBodyField = (props: ITemplateBodyField) => {
    return (
        <TemplatizedTextField
            {...props}
            showModeToggle={true}
            modeToggleTooltip={
                <p>
                    Use multi-line view to draft the notification body with clear line breaks. Switching views will
                    remove any line breaks.
                </p>
            }
            label="Body"
            limits={{
                max: 140,
                aboveMaxMessage: 'Body may be cut off on some devices.',
                displayMode: 'custom',
            }}
        />
    )
}

export default TemplateBodyField
